import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import {addItem} from '../redux/features/pageSlice'

const ProductDetails = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const dispatch = useDispatch();
  const handleAdd = (product) => {
      dispatch(addItem(product));
  };

  useEffect(() => {
    fetch(`https://fakestoreapi.com/products/${id}`)
      .then(res => res.json())
      .then(setItem) // ✅ Directly setting the item
      .catch(console.error); // ✅ Simple error handling
  }, [id]);

  if (!item) return <div className="text-center">Loading...</div>;

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <div className="flex flex-col lg:flex-row items-center">
        {/* Product Image */}
        <div className="flex-shrink-0 mb-6 lg:mb-0 lg:w-1/3">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-64 object-fill rounded-lg shadow-md"
          />
        </div>

        {/* Product Info */}
        <div className="lg:w-2/3 lg:pl-8">
          <h2 className="text-3xl font-semibold text-gray-800 mb-4">{item.title}</h2>
          <p className="text-xl text-gray-600 mb-4">${item.price}</p>
          <p className="text-gray-700 mb-4">{item.description}</p>

          {/* Add to Cart Button */}
          <button onClick={() => handleAdd({item})} className="bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-600 focus:outline-none">
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
